<template>
  <div class="h-full">
    <el-scrollbar
      ref="scrollbarRef"
      :style="`height: calc(100% - 28px);`"
    >
      <steps
        :steps="getTaskDistributeSteps()"
        :max-width="1400"
        :active-key="currStepKey"
      />

      <upload v-if="currStepKey === 'upload'" ref="uploadRef" :upload-form-data="uploadFormData" />
      
      <upload-results v-if="currStepKey === 'uploadResults'" ref="taxTableRef" :upload-data="uploadData" />
    </el-scrollbar>
    <div class="pb-[16px] pt-4">
      <el-button v-if="currStepKey === 'upload'" @click="closeAndBack">
        取消
      </el-button>
      <el-button v-if="currStepKey === 'upload'" type="primary" @click="saveImport">
        下一步
      </el-button>
      <el-button v-if="currStepKey === 'uploadResults'" @click="toPrevStep">
        再次导入
      </el-button>
      <el-button v-if="currStepKey === 'uploadResults'" type="primary" @click="handleSubmit">
        确定结果
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Upload from './components/upload.vue';
import uploadResults from './components/uploadResults.vue';
import { Steps } from '@vue3/components';
import { computed, PropType, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElScrollbar, ElMessage, MessageHandler } from 'element-plus';
import { IFreelancerImportItem, IImportFreelancer } from '@core/main/types';
import { useTabsStore } from '@core/main';
import { toElScrollTop } from '@core/tools';

const { closeAndBack, updatetRouteQuery } = useTabsStore();

defineOptions({ name: 'PersonnelImport' }); // 导入人员

defineProps({
  from: {
    type: String as PropType<'saas' | 'company' | 'agent' | 'server'>,
    default: 'saas',
  },
  type: {
    type: String as PropType<'crowd' | 'broker'>,
    default: 'crowd',
  },
});

const route = useRoute();
const router = useRouter();

function getTaskDistributeSteps() {
  return [
    {
      title: '人员信息导入',
      key: 'upload',
    },
    {
      title: '上传结果',
      key: 'uploadResults',
    },
  ].filter(Boolean);
}

const saving = ref(false);
const currStepKey = computed(() => route.query.step as string || 'upload');
const uploadRef = ref<InstanceType<typeof Upload>>();
const uploadData = ref<IFreelancerImportItem[]>([]);
const uploadFormData = ref<IImportFreelancer>({} as IImportFreelancer); 
const taxTableRef = ref<InstanceType<typeof uploadResults>>();

function toPrevStep() {
  replaceRoute({
    id: route.query.id,
    step: 'upload',
  });
}

async function saveImport() {
  const valid = await uploadRef.value?.validate();

  if (!valid) return;

  try {

    uploadData.value = uploadRef.value.getValues()?.items;
    uploadFormData.value = uploadRef.value.getValues();
    saveHandler(
      async () => {
        replaceRoute({
          id: route.query.id,
          step: 'uploadResults',
        });
      },
    );
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function handleSubmit() {
  try {
    closeAndBack();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function saveHandler(callback: () => Promise<void | MessageHandler>) {
  saving.value = true;

  try {
    await callback();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  saving.value = false;
}

function replaceRoute(v: Record<string, any>) {
  router.replace({
    path: route.path,
    query: {
      ...route.query,
      ...v,
    },
  });
  updatetRouteQuery({ ...v });
  toElScrollTop();
}

</script>

<style lang="scss" scoped>
:deep(.steps-items-box) {
  min-height: unset !important;
}
</style>
